
<template>
    <div class="center">
      <div>
        <div class="d-flex justify-content-end">
          <vs-button
            :disabled="!selected.length"
            success
            flat
            @click="activeArchivo =! activeArchivo"
            class="mb-2 ml-auto"
          >
            <i class="fas fa-upload mr-2"></i>Subir documento<span class="ml-1"> {{selected.length == users.length ? ' por grupo' : ' individualmente'}}</span>
          </vs-button>
        </div>
      </div>
      <!-- <tabla-documentos-generales :documentosGenerales="documentosGenerales" @documentosAcciones="documentosAcciones"></tabla-documentos-generales> -->
      <vs-button
        danger
        flat
        class="ml-auto"
        :disabled="!selected.length"
        @click="activeEliminar =! activeEliminar, tipoAccion = 'alumno'"
      >
        <i class="fas fa-trash-alt mr-2"></i>Eliminar documentos por alumno
      </vs-button>
      <vs-row>
          <vs-col w="12">
          </vs-col>
          <vs-col sm="12" lg="5" class="ml-auto">
              <vs-input v-model="search" placeholder="Buscar">
                  <template #icon>
                      <i class="fas fa-search"></i>
                  </template>
              </vs-input>
          </vs-col>
      </vs-row>
      <vs-table
        v-model="selected"
        >
        <template #thead>
          <vs-tr>
            <vs-th style="width: 50px !important">
              <vs-checkbox
                  :indeterminate="selected.length == users.length" v-model="allCheck"
                  @change="selected = $vs.checkAll(selected, users)"
              />
            </vs-th>
            <vs-th>
              Alumno
            </vs-th>
            <vs-th>
              Documentos
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in $vs.getSearch(users, search)"
            :data="tr"
            :is-selected="!!selected.includes(tr)"
            class="divisionLineas"
          >
            <vs-td checkbox>
              <vs-checkbox :val="tr" v-model="selected"/>
            </vs-td>
            <vs-td>
              <md-chip style="background: rgb(214, 234, 248); color: #2874A6" class="mb-1 fontMedium mini-chip col-blue">
                  <p>No. Lista: <strong><span>{{ tr.no_lista }}</span></strong></p>
              </md-chip>
              <p class="mb-0"><small><i>ALUMNO</i></small></p>
              <p><strong>{{tr.alumno_name}}</strong></p>
              <p class="mb-0"><small><i>MATRÍCULA</i></small></p>
              <p><strong>{{tr.alumno_matricula}}</strong></p>
            </vs-td>
            <vs-td>
              <div v-for="(doc, d) in tr.documentos" :key="d" class="py-2 borderBottom" :class="doc.fecha_visualizacion || doc.descripcion ? '' : 'd-flex justify-content-between flex-reverse'">
                <div class="d-flex justify-content-between">
                  <div>
                    <div v-if="doc.fecha_visualizacion">
                      <p class="mb-0"><strong><small>FECHA LÍMITE DE VISUALIZACIÓN</small></strong></p>
                      <p>{{doc.fecha_visualizacion}}</p>
                    </div>
                    <div v-if="doc.descripcion">
                      <p class="mb-0"><strong><small>DESCRIPCIÓN</small></strong></p>
                      <p>{{doc.descripcion}}</p>
                    </div>
                  </div>
                  <div class="d-flex">
                    <!-- <vs-tooltip>
                      <vs-button
                        flat
                        warn
                        @click="activeEditar =! activeEditar, selectRow = doc"
                      >
                        <i class="far fa-edit"></i>
                      </vs-button>
                      <template #tooltip>
                        Editar 
                      </template>
                    </vs-tooltip> -->
                    <vs-tooltip>
                      <vs-button
                        flat
                        danger
                        :disabled="selected[0]"
                        @click="activeEliminarIndividual =! activeEliminarIndividual, selectRow = doc"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </vs-button>
                      <template #tooltip>
                        Eliminar documento
                      </template>
                    </vs-tooltip>
                  </div>
                </div>
                <vs-button
                  @click="getDocumentosDownload(doc.id)"
                >
                  {{doc.original_filename}}
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <eliminar v-model="activeEliminar" :docSelect="selected" :tipoAccion="tipoAccion" @refreshTable="getRefresh"></eliminar>
      <editar v-model="activeEditar" :selectRow="selectRow"></editar>
      <eliminar-individual v-model="activeEliminarIndividual" :selectRow="selectRow" @refreshTable="getRefresh"></eliminar-individual>
      <archivo-nuevo v-model="activeArchivo" :selected="selected" :filtrosPadres="filtrosPadres" @refreshTable="getRefresh"></archivo-nuevo>
    </div>
</template>
<script>
import eliminar from './modal/eliminar.vue'
import eliminarIndividual from './modal/eliminar-individual.vue'
import editar from './modal/editar.vue'
import ArchivoNuevo from './modal/archivo_nuevo.vue'
import TablaDocumentosGenerales from './tabla-documentos-generales.vue'
import evaluaciones from '../../../api/requests/docente/evaluaciones.js'
    export default {
      props:[
        'users',
        'documentosGenerales',
        'filtrosPadres'
      ],
      data:() => ({
        search: '',
        allCheck: false,
        selected: [],
        activeEliminar: false,
        activeEliminarIndividual: false,
        activeEditar: false,
        activeArchivo: false,
        tipoModal: '',
        docSelect: [],
        selectRow: [],
        tipoAccion: ''
      }),
      components:{
        eliminar,
        editar,
        ArchivoNuevo,
        TablaDocumentosGenerales,
        eliminarIndividual
      },
      methods:{
        documentosAcciones(doc){
          this.docSelect = doc
        },
        async getDocumentosDownload(id){
          try{
            const url = '/api/documentos-docentes/'+ id
            window.open(url)
          }catch(error){
            console.log(error)
          }
        },
        getRefresh(){
          this.$emit('refreshTable')
        }
      }
    }
</script>

<style lang="scss" scoped>
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
    .borderBottom:not(:last-child){
      border-bottom: 1px solid rgb(197, 197, 197);
    }
</style>
<style>
  .flex-reverse{
    flex-direction: row-reverse
  }
  .pasos .md-steppers .md-steppers-navigation {
      box-shadow: none !important;
      color: red;
  }

  .vs-checkbox-label{
      margin-bottom: 0 !important;
  }

  input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: auto;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }

  .borderCopy{
      border-radius: 4px;
      border: 1px solid rgb(218, 218, 218);
      padding: 1%;
      align-items: center;
      margin-right: 1%;
  }
  .vs-avatar img{
      object-fit:contain;
  }

  .divisionLineas:not(:last-child){
      border-bottom: 1px solid #E5E7E9; 
  }
  
  .divisionLineas{
      padding: 2% 0;
  }
   
</style>

        